//main actions call these workers and actions those ended with STATE will change state

import { takeLatest, call, put } from "redux-saga/effects";
import {
    ADD_NEW_SERVICE_STATE,
    REMOVE_SERVICE_STATE,
    ADD_NEW_SERVICE,
    REMOVE_SERVICE,
    ADD_NEW_SERVICES_STATE,
    ADD_NEW_SERVICES,
    IMPORT_NEW_SERVICES
} from '../../constants/actions-types';
import {
    findAllService,
    saveService,
    deleteService
} from "./methods/serviceMethods";


function* workerFindAllServices() {
    try {
        const result = yield call(findAllService);
        yield put({ type: ADD_NEW_SERVICES_STATE, services: result })
    }
    catch (ex) {
        console.log(ex)
    }
}

function* workerSaveService(action) {
    try {
        const result = yield call(saveService, action.service);
        yield put({ type: ADD_NEW_SERVICE_STATE, service: result })
    }
    catch (ex) {
        console.log(ex)
    }
}

function* workerSaveAllServices(action) {
    try {
        let services = JSON.parse(action.services);
        const result = yield call(saveService, services);
        yield put({ type: ADD_NEW_SERVICES })
    }
    catch (ex) {
        console.log(ex)
    }
}

function* workerDeleteService(action) {
    try {
        yield call(deleteService, action.service);
        yield put({ type: REMOVE_SERVICE_STATE, service: action.service })
    }
    catch (ex) {
        console.log(ex)
    }
}

function* watcherSaveAllServices() {
    yield takeLatest(IMPORT_NEW_SERVICES, workerSaveAllServices);
}


function* watcherFindAllServices() {
    yield takeLatest(ADD_NEW_SERVICES, workerFindAllServices);
}


function* watcherSaveService() {
    yield takeLatest(ADD_NEW_SERVICE, workerSaveService);
}


function* watcherRemoveService() {
    yield takeLatest(REMOVE_SERVICE, workerDeleteService);
}

export {
    watcherSaveService,
    watcherRemoveService,
    watcherFindAllServices,
    watcherSaveAllServices
}



